<template>
  <section class="vip">
    <article class="article">
      <h1 class="article-title">开通会员</h1>
      <h2 class="article-desc"><span>&yen;</span>&nbsp;<span>168</span>&nbsp;元/年</h2>
      <router-link to="/login"><button class="open-vip">开通会员</button></router-link>
      <section class="article-inner">
        <p>会员权益：</p>
        <ul class="vip-list">
          <li v-for="(item, idx) in vipList" :key="idx">{{idx+1}}、{{item}}</li>
        </ul>
        <div class="notice">
          <p>注意：满足以下情况无法享受会员特权权益：</p>
          <ul class="notice-list">
            <li v-for="(item, idx) in notice" :key="idx">{{item}}</li>
          </ul>
        </div>
      </section>
    </article>
  </section>
</template>

<script>
import zmBanner  from '@/components/Banner.vue'
export default {
  components: {
    zmBanner
  },
  props: {},
  data () {
    return {  
      vipList: ['用户在支付一定会员服务费用后可享受本站会员服务。', 
      '会员有效期内可重复购买会员服务，购买成功后，同种类型会员服务有效期将在原有基础上顺延。',
      '以“年”为单位的会员服务，按照每年365天计算会员有效期。',
      '会员服务过期后，未购买的定制数据报告需要重新购买或续费会员后才能继续享受定制服务。'],
      notice: ['如若恶意注册、作弊阅读、盗用或冒用他人信息注册将被取消会员资格。']
    }
  }
}
</script>
<style scoped>
.article {
  width: 1024px;
  padding: 50px 0 130px; 
  margin: 50px auto 0;
  box-shadow: 0 0 5px 5px rgba(0, 0, 0, .05);
  background-color: #fff;
}
.article-title {
  font-size: 24px;
  text-align: center;
}
.article-desc {
  margin: 30px 0;
  font-size: 18px;
  text-align: center;
}
.article-desc > span {
  font-size: 36px;
  color: #ee2929;
}
.article-desc > span:first-child {
  font-size: 30px;
}
.article-inner {
  width: 810px;
  margin: 0 auto;
  color: #666;
  line-height: 30px;
  font-size: 18px;
}
.article-inner>p:first-child {
  color: #222;
  font-weight: 500;
}
.vip-list {
  font-size: 14px;
}
.notice {
  margin-top: 64px;
  font-size: 14px;
}
.article button.open-vip{
  display: block;
  color: #fff;
  background-color: #34a2f6;
  width: 180px;
  height: 46px;
  line-height: 46px;
  border-radius: 8px;
  margin: 0 auto 60px;
}
</style>